export default {
  statusBadge: {
    draft: '草稿',
    preprocessing: '前處理中',
    awaitingUserMeshing: '等待網格化',
    awaitingBcReview: '等待邊界條件審查',
    awaitingMoboReview: '等待審查',
    running: '執行中',
    completed: '已完成',
    completedWithIssues: '已完成（有問題）',
    failed: '失敗',
    cancelled: '已取消',
  },
  dashboard: {
    sortDateCreated: '建立日期',
    sortName: '名稱',
    moreFilters: '更多篩選',
    typeFilter: '類型',
    tagFilter: '標籤',
    typeFea: 'FEA',
    typeCfd: 'CFD',
    typeCht: 'CHT',
    tagCfdExt: 'CFD · 外部',
    tagCfdInt: 'CFD · 內部',
    tagCht: 'CHT',
    tagFea: 'FEA',
    tagTet: 'Tet',
    tagHex: 'Hex',
    tagPoly: 'Poly',
    noTypes: '沒有類型',
    noTags: '沒有標籤',
    noStatuses: '沒有狀態',
    clearFilter: '清除篩選',
    selectAllStudies: '選取所有研究',
    selectStudy: '選取 {{name}}',
    colName: '名稱',
    colStatus: '狀態',
    colDesignPts: '設計點',
    colProgress: '進度',
    colCreated: '建立時間',
    colCompleted: '完成時間',
    colUpdated: '更新時間',
    colActions: '操作',
    startNewStudyTitle: '開始新的研究',
    startNewStudySubtitle: '設定 DOE、代理模型或 GCI 研究。',
    newStudy: '新增研究',
    studies: '研究',
    studiesCount_one: '{{count}} 項研究',
    studiesCount_other: '{{count}} 項研究',
    searchStudies: '搜尋研究…',
    selectedCount_one: '已選取 {{count}} 項',
    selectedCount_other: '已選取 {{count}} 項',
    clear: '清除',
    delete: '刪除',
    tabAll: '全部',
    tabDraft: '草稿',
    tabRunning: '執行中',
    tabCompleted: '已完成',
    tabFailed: '失敗',
    emptyTitleNoStudies: '尚無研究',
    emptyTitleNoMatch: '沒有符合篩選條件的研究',
    emptyHintNoStudies: '點擊上方的「新增研究」開始。',
    emptyHintNoMatch: '請嘗試其他篩選條件或搜尋字詞。',
    emptyHintSearchMore:
      '已載入的研究中沒有符合項目 — 請捲動以載入更多，或改用其他搜尋。',
    loadingStudies: '正在載入研究…',
    tableEmpty: '尚無可用的研究。',
    studyNameLabel: '研究名稱',
    renameTooltip: '{{name}} — 雙擊以重新命名',
    renameFailed: '失敗',
  },
  deleteDialog: {
    title_one: '要刪除 {{count}} 項研究嗎？',
    title_other: '要刪除 {{count}} 項研究嗎？',
    description_one: '將從您的研究清單中移除此研究及其結果。此操作無法復原。',
    description_other:
      '將從您的研究清單中移除這 {{count}} 項研究及其結果。此操作無法復原。',
    cancel: '取消',
    confirm_one: '刪除 {{count}} 項研究',
    confirm_other: '刪除 {{count}} 項研究',
  },
  libraryCard: {
    points: '{{done}}/{{total}} 點',
  },
  reviewView: {
    evidence: '佐證資料',
  },
  userMeshing: {
    geometryFallback: '幾何',
    sectionLabel: '設計點 · 網格化',
    allFaceNamed_one: '{{count}} 個 DP 已完成面命名。',
    allFaceNamed_other: '全部 {{count}} 個 DP 已完成面命名。',
    readyWhenFaceNamed_one: '待 {{count}} 個 DP 完成面命名後即可就緒。',
    readyWhenFaceNamed_other: '待全部 {{count}} 個 DP 完成面命名後即可就緒。',
    simsQueueHint: '確認後模擬將自動排入佇列。',
    completeAndRun: '完成網格化並執行模擬',
    atAGlance: '研究概覽',
    designPoints: '設計點',
    meshTemplate: '網格範本',
    fromStudy: '來自研究',
    meshesYoursTitle: '網格永遠屬於您。',
    meshesYoursBody:
      '您在此處產生的任何內容也會出現在獨立的 MeshGen 中。取消研究不會將其刪除。',
    cancelStudy: '取消研究…',
    readOnlyTitle: '僅供檢視',
    readOnlyPastMeshing:
      '此研究的網格化已完成。可開啟網格檢視，但在此所做的變更已無法套用到執行。',
    readOnlyRole:
      '您可以檢視這些網格，但無法變更。只有研究擁有者或編輯者可以完成網格化。',
  },
  cancelStudy: {
    action: '取消研究…',
    cancelled: '已取消研究。',
    failed: '取消失敗。',
  },
  progress: {
    phaseNotUsed: '此研究未使用此階段',
    phaseRailAria: '{{label}}：{{total}} 個中已完成 {{done}} 個',
    notUsed: '未使用',
    countActive_one: '{{count}} 個進行中',
    countActive_other: '{{count}} 個進行中',
    countFailed_one: '{{count}} 個失敗',
    countFailed_other: '{{count}} 個失敗',
    progress: '進度',
    designPointsComplete_one: '{{count}} 個設計點中已完成 {{completed}} 個',
    designPointsComplete_other: '{{count}} 個設計點中已完成 {{completed}} 個',
    failedCount_one: '{{count}} 個失敗',
    failedCount_other: '{{count}} 個失敗',
    meshing: '網格化',
    simulating: '模擬',
    completed: '已完成',
    running: '執行中',
    pending: '待處理',
    failed: '失敗',
    cancelled: '已取消',
    studyConfiguration: '研究設定',
    noSolverSettings: '尚未設定求解器設定。',
    sweepVariables: '掃描變數',
    someDesignPointsFailed: '部分設計點失敗。',
    failedDuringMeshing_one: '{{count}} 個在網格化期間失敗',
    failedDuringMeshing_other: '{{count}} 個在網格化期間失敗',
    failedDuringPreparation_one: '{{count}} 個在準備期間失敗',
    failedDuringPreparation_other: '{{count}} 個在準備期間失敗',
    failedDuringSimulation_one: '{{count}} 個在模擬期間失敗',
    failedDuringSimulation_other: '{{count}} 個在模擬期間失敗',
    timestampCreated: '建立',
    timestampCompleted: '完成',
    timestampFailed: '失敗',
    timestampCancelled: '取消',
    timestampStarted: '開始',
    timestampUpdated: '更新',
  },
} as const;
